import { useState } from 'react';
import { Camera, Shield, Share2 } from 'lucide-react';
import './Onboarding.css';

const SLIDES = [
  {
    icon: Camera,
    title: 'Scan Any Plate',
    description: 'Point your camera at a license plate or type it in manually to instantly look up any rideshare vehicle.',
    color: '#F7C600',
  },
  {
    icon: Shield,
    title: 'Get Instant Verification',
    description: 'See if the vehicle is a registered rideshare in NYC or Chicago — including car photos, license status, and more.',
    color: '#22c55e',
  },
  {
    icon: Share2,
    title: 'Share Your Ride',
    description: 'Send trip details and live location to friends or family so they know you\'re safe.',
    color: '#3b82f6',
  },
];

export default function Onboarding({ onComplete }) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [touchStart, setTouchStart] = useState(null);

  const handleNext = () => {
    if (currentSlide < SLIDES.length - 1) {
      setCurrentSlide(currentSlide + 1);
    } else {
      handleFinish();
    }
  };

  const handleFinish = () => {
    localStorage.setItem('tlc_onboarding_seen', 'true');
    onComplete();
  };

  const handleTouchStart = (e) => {
    setTouchStart(e.touches[0].clientX);
  };

  const handleTouchEnd = (e) => {
    if (touchStart === null) return;
    const touchEnd = e.changedTouches[0].clientX;
    const diff = touchStart - touchEnd;

    if (Math.abs(diff) > 50) {
      if (diff > 0 && currentSlide < SLIDES.length - 1) {
        setCurrentSlide(currentSlide + 1);
      } else if (diff < 0 && currentSlide > 0) {
        setCurrentSlide(currentSlide - 1);
      }
    }
    setTouchStart(null);
  };

  const slide = SLIDES[currentSlide];
  const Icon = slide.icon;
  const isLast = currentSlide === SLIDES.length - 1;

  return (
    <div
      className="onboarding-overlay"
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      <button className="onboarding-skip" onClick={handleFinish}>
        Skip
      </button>

      <div className="onboarding-content">
        <div className="onboarding-icon-ring" style={{ borderColor: slide.color }}>
          <Icon size={40} color={slide.color} />
        </div>

        <h2 className="onboarding-title">{slide.title}</h2>
        <p className="onboarding-desc">{slide.description}</p>
      </div>

      <div className="onboarding-footer">
        <div className="onboarding-dots">
          {SLIDES.map((_, i) => (
            <button
              key={i}
              className={`onboarding-dot ${i === currentSlide ? 'active' : ''}`}
              onClick={() => setCurrentSlide(i)}
              style={i === currentSlide ? { background: slide.color } : {}}
            />
          ))}
        </div>

        <button
          className="onboarding-next-btn"
          onClick={handleNext}
          style={{ background: slide.color }}
        >
          {isLast ? 'Get Started' : 'Next'}
        </button>
      </div>
    </div>
  );
}
